/**
 * canonical-turbo-hook.js
 * ============================================================
 * Turbo theme re-initialization hook.
 * Split into two passes:
 *   1. Immediate — runs on DOMContentLoaded, no fetch needed
 *   2. Deferred — runs after canonical:loaded, needs merged data
 * ============================================================
 */

(function () {
  'use strict';

  // ── Inject styles once ───────────────────────────────────────
  if (!document.getElementById('canonical-turbo-hook-styles')) {
    var style = document.createElement('style');
    style.id = 'canonical-turbo-hook-styles';
    style.textContent = [
      '.sizeswatch.size-active {',
      '  outline: 2px solid #333;',
      '  border-radius: 6px;',
      '  background-color: rgba(0,0,0,0.04);',
      '}',
      '.sizeswatch.size-active label,',
      '.sizeswatch.size-active .size_label_custom {',
      '  font-weight: bold;',
      '}',
      '#canonical-size-hint {',
      '  display: none;',
      '  font-size: 12px;',
      '  font-style: italic;',
      '  color: #888;',
      '  line-height: 1.4;',
      '  max-width: 160px;',
      '  align-self: center;',
      '  padding-left: 16px;',
      '  margin: 0;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ══════════════════════════════════════════════════════════════
  // PASS 1 — Immediate (no fetch needed)
  // Runs as soon as DOM is ready. Handles purely visual things
  // that don't depend on merged variant data.
  // ══════════════════════════════════════════════════════════════
  function immediatePass() {
    var $ = window.jQuery || window.$;
    if (!$) return;

    // ── Vendor label above product title ──────────────────────
    if (!document.getElementById('canonical-vendor-label')) {
      var vendorImg = document.querySelector('.vendor_img');
      var vendorName = vendorImg ? vendorImg.alt : null;
      var $title = $('h1.product_name').first();
      if (vendorName && $title.length) {
        var label = document.createElement('p');
        label.id = 'canonical-vendor-label';
        label.textContent = vendorName;
        label.style.cssText = [
          'font-size: 11px',
          'font-weight: 600',
          'letter-spacing: 0.1em',
          'text-transform: uppercase',
          'color: #c0392b',
          'margin: 0 0 6px 0',
          'font-family: inherit'
        ].join(';');
        $title[0].parentNode.insertBefore(label, $title[0]);

        var titleText = $title.text().trim();
        if (titleText.toLowerCase().indexOf(vendorName.toLowerCase()) === 0) {
          $title.text(titleText.substring(vendorName.length).trim());
        }
      }
    }

    // ── Hide price-ui unavailable badge ────────────────────────
    $('.price-ui-badge__sticker--unavailable').hide();

    // ── Price font size ────────────────────────────────────────
    fixPriceSizes();

    // ── Pre-highlight default size ─────────────────────────────
    var defaultVariantId = $('.multi_select option:selected').val();
    if (defaultVariantId && window.productVariants) {
      var defaultVariant = window.productVariants.find(function (v) {
        return String(v.id) === String(defaultVariantId);
      });
      if (defaultVariant && defaultVariant.option1) {
        var defaultSize = defaultVariant.option1;
        var $defaultSwatch = $('.sizeswatch').filter(function () {
          return $(this).find('#size_label_' + defaultSize).length > 0;
        });
        if ($defaultSwatch.length) {
          $('.swatch-element.sizeswatch').removeClass('size-active');
          $defaultSwatch.addClass('size-active');
        }
      }
    }

    // ── Size hint wrapper ──────────────────────────────────────
    if (!document.getElementById('canonical-size-hint')) {
      var $sizeArea = $('.swatch.is-flex.is-flex-wrap').first();
      if ($sizeArea.length) {
        $sizeArea.wrap('<div id="canonical-size-hint-wrapper" style="display:flex;flex-direction:row;align-items:center;flex-wrap:nowrap;"></div>');
        $('#canonical-size-hint-wrapper').append(
          '<p id="canonical-size-hint">' +
          'If the model isn\'t updating when a new color is chosen, ' +
          'select a new size. Sizes shown are in stock.' +
          '</p>'
        );
      }
    }

    // ── Size click highlight ───────────────────────────────────
    $('.swatch-element.sizeswatch').off('click.sizeactive').on('click.sizeactive', function () {
      $('.swatch-element.sizeswatch').removeClass('size-active');
      $(this).addClass('size-active');
    });
  }

  // ── Fix price font sizes ───────────────────────────────────
  function fixPriceSizes() {
    document.querySelectorAll('span.current_price').forEach(function (el) {
      el.style.fontSize = '22px';
    });
  }

  // ══════════════════════════════════════════════════════════════
  // PASS 2 — Deferred (needs merged variant data)
  // Runs after canonical:loaded. Handles availability logic.
  // ══════════════════════════════════════════════════════════════
  function deferredPass(mergedVariants) {
    var $ = window.jQuery || window.$;
    if (!$) return;

    var availableVariantIds = {};
    var availableColors = {};
    var lastSelectedSize = null;

    mergedVariants.forEach(function (v) {
      if (v.available) {
        availableVariantIds[String(v.id)] = true;
        if (v.option2) {
          var colorSlug = v.option2
            .toLowerCase()
            .replace(/[\s\/]+/g, '-')
            .replace(/[^a-z0-9\-]/g, '');
          availableColors[colorSlug] = true;
        }
      }
    });

    console.log('[TurboHook] Available variant IDs: ' + Object.keys(availableVariantIds).length);
    console.log('[TurboHook] Available colors: ' + Object.keys(availableColors).length);

    // ── Extract product ID ─────────────────────────────────────
    var productId = null;
    var productClassMatch = ($('[class*="product-"]').filter(function () {
      return /product-\d{10,}/.test($(this).attr('class') || '');
    }).first().attr('class') || '').match(/product-(\d{10,})/);
    if (productClassMatch) productId = productClassMatch[1];

    // ── Fix COLOR swatches ─────────────────────────────────────
    $('.swatch-element:not(.sizeswatch)').each(function () {
      var classes = $(this).attr('class') || '';
      var match = classes.match(/([a-z0-9][a-z0-9\-]*)-swatch/);
      if (match && availableColors[match[1]]) {
        $(this).removeClass('soldout');
        $(this).find('img.crossed-out, img.soldout, .soldout_badge').hide();
      }
    });

    // ── Fix SIZE swatches ──────────────────────────────────────
    function fixSizeSwatches() {
      $('.swatch-element.sizeswatch').each(function () {
        var variantId = String($(this).data('id') || '');
        if (variantId && availableVariantIds[variantId]) {
          $(this).removeClass('soldout');
          $(this).find('img.crossed-out, img.soldout, .soldout_badge').hide();
        }
      });
    }

    function reapplySizeHighlight() {
      var $currentActive = $('.sizeswatch.size-active:visible');
      if (!$currentActive.length) {
        var $firstVisible = $('.sizeswatch:visible').first();
        if ($firstVisible.length) {
          $('.sizeswatch').removeClass('size-active');
          $firstVisible.addClass('size-active');
        }
      }
    }

    function updateHint() {
      if (!lastSelectedSize) { $('#canonical-size-hint').fadeOut(200); return; }
      var $sel = $('.sizeswatch').filter(function () {
        return $(this).find('#size_label_' + lastSelectedSize).length > 0;
      });
      if ($sel.length && !$sel.is(':visible')) {
        $('#canonical-size-hint').fadeIn(200);
      } else {
        $('#canonical-size-hint').fadeOut(200);
      }
    }

    fixSizeSwatches();

    // ── Re-bind size click with hint + last selected tracking ──
    $('.swatch-element.sizeswatch').off('click.sizeactive').on('click.sizeactive', function () {
      $('.swatch-element.sizeswatch').removeClass('size-active');
      $(this).addClass('size-active');
      var sizeLabel = $(this).find('[id^="size_label_"]').attr('id');
      if (sizeLabel) lastSelectedSize = sizeLabel.replace('size_label_', '');
      setTimeout(updateHint, 300);
    });

    // ── Set lastSelectedSize from default ──────────────────────
    var defaultVariantId = $('.multi_select option:selected').val();
    var defaultVariant = mergedVariants.find(function (v) {
      return String(v.id) === String(defaultVariantId);
    });
    if (defaultVariant && defaultVariant.option1) {
      lastSelectedSize = defaultVariant.option1;
    }

    // ── Patch changesizesstatus ────────────────────────────────
    if (window.changesizesstatus && !window.changesizesstatus._patched) {
      var original = window.changesizesstatus;
      window.changesizesstatus = function (color) {
        original.call(this, color);
        setTimeout(function () {
          fixSizeSwatches();
          fixPriceSizes();
          reapplySizeHighlight();
          updateHint();
        }, 200);
      };
      window.changesizesstatus._patched = true;
      console.log('[TurboHook] Patched changesizesstatus.');
    }

    // ── Initialize page state with default variant ─────────────
    if (productId && window.selectCallback && defaultVariant) {
      var variantIdField = document.querySelector('[name="id"]') || document.querySelector('.product-select');
      var fakeSelector = { product: { id: productId }, variantIdField: variantIdField };
      try {
        window.selectCallback(defaultVariant, fakeSelector);
      } catch (e) {
        console.warn('[TurboHook] selectCallback failed:', e);
      }
    }

    setTimeout(updateHint, 200);
    console.log('[TurboHook] Deferred pass done.');
  }

  // ── Run immediate pass on DOMContentLoaded ─────────────────
  function runImmediate() {
    // Small defer to let jQuery and theme JS initialize first
    setTimeout(immediatePass, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runImmediate);
  } else {
    runImmediate();
  }

  // ── Run deferred pass after canonical:loaded ───────────────
  if (window.canonicalLoaderResult) {
    deferredPass(window.canonicalLoaderResult.variants);
  } else {
    document.addEventListener('canonical:loaded', function (e) {
      deferredPass(e.detail.variants);
    });
  }

})();